import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import ListPageHeader, { ListPageHeaderLeft, ListPageHeaderRight } from "../Misc/ListPageHeader";
import {
  Box,
  Stack,
  Link,
  FormControlLabel,
  Checkbox,
  Tooltip,
  OutlinedInput,
  MenuItem,
  Select,
  Menu,
  Button,
  InputAdornment,
} from "@mui/material";
import { ObjectLayer } from "../../Core/Api/Types/object-layer";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import DataTable, { CellSize } from "../Table/table";
import { assetService, cacheService, searchService, thumbnailService } from "../../Core/Api/services";
import { GetEnumValueLabelMap, GetObjectStatusLabel, OpenLinkInNewTab, UserHasAcl } from "../../Utils/helpers";
import { routePaths } from "../../Router/router";
import { ObjectStatus } from "../../Core/Api/Types/object-status";
import AssetStatus from "../Misc/Status/AssetStatus/asset-status";
import { CreateNewDbMetadataValue, GetMetadataById, GetMetadataByTagName } from "../../Core/Utils/asset-object-utils";
import { GridActionsCellItem, GridColDef, GridRowParams } from "@mui/x-data-grid";
import AdamChannelsPageFilters from "./adam-channels-page-filters";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { DateRange, LocalizationProvider } from "@mui/x-date-pickers-pro";
import TableCellDateTime from "../Table/TableCellDateTime/table-cell-date-time";
import {
  AdamThumbnailBody,
  CHANNELS_VALUE_LABEL,
  handleAddDateFilter,
  parseDates,
  handleAR,
  shortcutsItems,
} from "./adam-trailers";
import useCustomSnackbar from "../../Utils/Hooks/useCustomSnackbar";
import BookIcon from "@mui/icons-material/Book";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import SearchIcon from "@mui/icons-material/Search";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useLocation, useNavigate } from "react-router";
import { AclTypes } from "../../Core/Api/Types/acl-types";
import { UpdateMetadataFieldsRequest } from "../../Core/Api/Types/update-metadata-fields-request";
import { BaseMetadataType } from "../../Core/Api/Types/base-metadata-type";
import { ModalContext } from "../Modals";
import ModalSetPrgIdAdam, { ModalSetPrgIdAdamElementProps } from "../Modals/ModalSetPrgIdAdam/modal-set-prg-id-adam";
import { SearchRequestNative } from "../../Core/Api/Types/search-request-native";
import { IDbBaseMetadataValueInfos } from "../../Core/Api/Types/i-db-base-metadata-value-infos";
import { ObjectType } from "../../Core/Api/Types/object-type";
import GlobalConst from "../../Core/Utils/Constants/globals";
import TableCellAdamObjectInfos from "../Table/TableCellAdamObjectInfos/table-cell-adam-object-infos";
import { Link as RouterLink } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  AddOrUpdateFilter,
  AddOrUpdateStatusHistoryFilter,
  GetFilters,
  GetStatusHistoryFilter,
  RemoveAllFilters,
  RemoveFilterById,
  RemoveStatusHistoryFilter,
  StatusHistoryFilter,
  StoreFiltersState,
} from "../../Redux/Reducers/redux-slice-filters";
import { ComputeMetadataBaseType } from "../../Core/Utils/functions";
import FiltersList from "../Filters/FiltersList/filters-list";
import { MetadataFieldValueObjectTypes } from "../../Core/Api/Types/metadata-field-value-object-types";
import { MuiEvent } from "@mui/x-data-grid";
import { CloseOutlined } from "@mui/icons-material";
import TableUuids from "../Table/table-uuids";
import { TableCellAdamVignette } from "../Table/TableCellAdamVignette/TableCellAdamVignette";
import useAdamDateFilterLinkValues from "../../Utils/Hooks/useAdamDateFilterLinkValues";
import { useTheme } from "@mui/system";
import "./date-picker.css";
interface AdamSourcesProps {}

const AdamSources: FC<AdamSourcesProps> = (props) => {
  const page = "adamSources";
  const { t } = useTranslation();
  const location = useLocation();
  const enqueueCustomSnackbar = useCustomSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  const [rows, setRows] = React.useState<DbAssetObjectInfos[]>([]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mouseOffset, setMouseOffset] = useState(1);
  const [spliceThumbnailUrl, setSpliceThumbnailUrl] = useState("");
  const [thumbnailUrl, setThumbnailUrl] = useState("");

  const theme = useTheme();

  const authKey = cacheService.GetAuthKey();

  const openMenu = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const today = dayjs();

  const metadatas = cacheService.GetMetadata();

  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const prgIdMeta = metadatas.find((x) => x.tagName === "rc_prg_id");
  const prgReserverMeta = metadatas.find((x) => x.tagName === "rc_prg_reserver");
  const adamTypeMeta = metadatas.find((x) => x.tagName === "adamAssetType");
  const dateDiffMeta = metadatas.find((x) => x.tagName === "programDateDiffusion");
  const cachedFilters = cacheService.GetPageFilter(location.pathname) ?? {};
  const [linkedDateFilterId, setLinkedDateFilterId] = React.useState<number | null>(null);
  const channelMeta = useMemo(() => metadatas.find((x) => x.tagName === "source_lib_chaines"), [metadatas]);
  const channelChildMeta = useMemo(() => metadatas.find((x) => x.tagName === "rc_ba_lib_chaine_enfant"), [metadatas]);
  const techWidthMeta = useMemo(() => metadatas.find((x) => x.tagName === "techWidth"), [metadatas]);
  const techHeightMeta = useMemo(() => metadatas.find((x) => x.tagName === "techHeight"), [metadatas]);

  const [currentWidth, setCurrentWidth] = useState(300);
  const [currentHeight, setCurrentHeight] = useState(168);

  const statusHistoryFilter = useSelector(GetStatusHistoryFilter);
  const filters = useSelector(GetFilters);
  const [filterDateType, setFilterDateType] = React.useState<"rc_prg_datesheures_diffs" | "ingest">(
    "rc_prg_datesheures_diffs"
  );
  const [linkedStatusHistoryFilter, setLinkedStatusHistoryFilter] = React.useState<ObjectStatus>(
    ObjectStatus.ParsedAndProbbed
  );
  const filterChannel = useMemo(() => {
    const channels = filters.find((x) => x.id === channelMeta?.id)?.value || [];
    const subChannels = filters.find((x) => x.id === channelChildMeta?.id)?.value || [];
    return [...channels, ...subChannels];
  }, [filters]);

  const [dateValue, setDateValue] = React.useState<DateRange<Dayjs>>([null, null]);
  const [filterReceived, setFilterReceived] = React.useState<boolean>(cachedFilters["received"] ?? false);
  const [filterIdentified, setFilterIdentified] = React.useState<boolean>(cachedFilters["identified"] ?? false);
  const [searchText, setSearchText] = React.useState<string>("");
  const [autoFirstSearchReady, setAutoFirstSearchReady] = React.useState<boolean>(false);
  const [isFirstLoad, setIsFirstLoad] = React.useState<boolean>(true);

  const adamTypeFilter: IDbBaseMetadataValueInfos | null = useMemo(
    () =>
      adamTypeMeta
        ? {
            ...CreateNewDbMetadataValue(
              adamTypeMeta!.id,
              BaseMetadataType.DbStringMetadataValueInfos,
              "adamAssetType",
              "source"
            ),
            valueLabel: "Source",
            targetLayer: ObjectLayer.Asset,
            hideFilter: true,
          }
        : null,
    [adamTypeMeta?.id]
  );

  const setPageCache = useCallback(() => {
    cacheService.SetPageCache(page, {
      filterReceivedSource: filterReceived,
      filterIdentifiedSource: filterIdentified,
      filters: filters,
      linkedDateFilterId: linkedDateFilterId,
      linkedStatusHistoryFilter: linkedStatusHistoryFilter,
      statusHistoryFilter: statusHistoryFilter,
      searchPattern: searchText,
    });
  }, [
    filterReceived,
    filterIdentified,
    filters,
    filters.length,
    linkedDateFilterId,
    linkedStatusHistoryFilter,
    statusHistoryFilter,
    statusHistoryFilter.length,
    searchText,
    page,
  ]);

  // handle page cached state
  useEffect(() => {
    const pageCache:
      | {
          filterReceivedSource: boolean;
          filterIdentifiedSource: boolean;
          filters: IDbBaseMetadataValueInfos[] | undefined;
          linkedDateFilterId: number | null;
          linkedStatusHistoryFilter: ObjectStatus | null;
          statusHistoryFilter: StatusHistoryFilter[] | undefined;
          searchPattern: string | undefined;
        }
      | undefined
      | null = cacheService.GetPageCache(page);
    if (pageCache) {
      setFilterReceived(pageCache.filterReceivedSource);
      setFilterIdentified(pageCache.filterIdentifiedSource);
      setLinkedDateFilterId(pageCache.linkedDateFilterId);
      if (pageCache.statusHistoryFilter && pageCache.statusHistoryFilter.length > 0) {
        dispatch(AddOrUpdateStatusHistoryFilter(pageCache.statusHistoryFilter[0]));
        setFilterDateType("ingest");
        setDateValue([
          dayjs(pageCache.statusHistoryFilter[0].startDate),
          dayjs(pageCache.statusHistoryFilter[0].endDate),
        ]);
        setAutoFirstSearchReady(true);
      }
      if (pageCache.filters && pageCache.filters.length > 0) {
        dispatch(StoreFiltersState(pageCache.filters));
        let dateRange;
        if (pageCache.filters.find((x) => x.id === dateDiffMeta?.id)) {
          setFilterDateType("rc_prg_datesheures_diffs");
          const startDate = pageCache.filters.find(
            (x) => x.id === dateDiffMeta?.id && x.valueLabel === "startDate"
          )?.value;
          const endDate = pageCache.filters.find((x) => x.id === dateDiffMeta?.id && x.valueLabel === "endDate")?.value;
          dateRange = [startDate, endDate];
        }
        if (pageCache.searchPattern) setSearchText(pageCache.searchPattern);
        if (dateRange && dateRange[0] && dateRange[1]) setDateValue([dayjs(dateRange[0]), dayjs(dateRange[1])]);
        setAutoFirstSearchReady(true);
      }
    }
    if (!pageCache || !(pageCache.filters && pageCache.filters.length > 0)) {
      handleAddDateFilter(dateValue, filterDateType, dispatch, setLinkedDateFilterId, today, dateDiffMeta);
      setAutoFirstSearchReady(true);
    }

    return () => {
      dispatch(RemoveAllFilters());
    };
  }, [page]);

  useEffect(() => {
    if (autoFirstSearchReady) search();
  }, [autoFirstSearchReady]);

  useEffect(() => {
    cacheService.SetPageCache(page, {
      filterReceivedSource: filterReceived,
      filterIdentifiedSource: filterIdentified,
      filters: filters,
      linkedDateFilterId: linkedDateFilterId,
      linkedStatusHistoryFilter: linkedStatusHistoryFilter,
      statusHistoryFilter: statusHistoryFilter,
      searchPattern: searchText,
    });
  }, [
    filters,
    filters.length,
    statusHistoryFilter,
    statusHistoryFilter.length,
    linkedStatusHistoryFilter,
    linkedDateFilterId,
    searchText,
    filterReceived,
    filterIdentified,
    searchText,
  ]);

  useEffect(() => {
    adamTypeFilter && dispatch(AddOrUpdateFilter(adamTypeFilter));
  }, [adamTypeFilter]);

  const search = useCallback(() => {
    if (!adamTypeMeta || !dateDiffMeta) {
      navigate("/");
      return;
    }

    setIsLoading(true);

    if (filters.length === 0) return;

    searchService
      .SearchBasic(
        new SearchRequestNative({
          outputLayer: ObjectLayer.Asset,
          hideTitleWithoutAsset: false,
          pattern: searchText.length > 0 ? searchText : "",
          metadata: filters,
          classifications: null,
          types: [ObjectType.Video, ObjectType.VideoClip, ObjectType.Audio, ObjectType.Image, ObjectType.AudioClip],
          statuses: null,
          statusHistory: statusHistoryFilter,
          onlyConfidential: null,
          titleCustomerIds: null,
          assetIds: null,
          createdBy: null,
          providerIds: null,
          limit: isFirstLoad ? 100 : null,
        })
      )
      .then((response) => {
        if (response.success && response.results) {
          setRows(response.results);

          cacheService.SetPageCache(page, {
            filterReceivedSource: filterReceived,
            filterIdentifiedSource: filterIdentified,
            filters: filters,
            linkedDateFilterId: linkedDateFilterId,
            linkedStatusHistoryFilter: linkedStatusHistoryFilter,
            statusHistoryFilter: statusHistoryFilter,
            searchPattern: searchText,
          });
        } else {
          enqueueCustomSnackbar(response.message!, "error");
          setRows([]);
        }
        setIsFirstLoad(false);
        setIsLoading(false);
      });
  }, [
    filterReceived,
    filterIdentified,
    filters,
    filters.length,
    linkedDateFilterId,
    linkedStatusHistoryFilter,
    statusHistoryFilter,
    statusHistoryFilter.length,
    searchText,
    isFirstLoad,
  ]);

  const handleThumbnailClick = useCallback(
    (objectId: number) => {
      setSpliceThumbnailUrl(
        thumbnailService.GetMergeThumbsSpliceImageByObjectId(
          objectId,
          GlobalConst.BROWSER_IMG_SPRITE_COUNT,
          cacheService.GetAuthKey()!
        )
      );
      handleAR(
        rows.find((x) => x.id === objectId) ?? null,
        techWidthMeta!.id,
        setCurrentWidth,
        techHeightMeta!.id,
        setCurrentHeight
      );
      setThumbnailUrl(thumbnailService.GetThumbRefByObjectId(objectId, cacheService.GetAuthKey()!));
    },
    [location.pathname, rows.length]
  );

  const handleFilterDateType = useCallback(
    (event) => {
      linkedDateFilterId && dispatch(RemoveFilterById(linkedDateFilterId));
      linkedStatusHistoryFilter && dispatch(RemoveStatusHistoryFilter(linkedStatusHistoryFilter));
      handleAddDateFilter(dateValue, event.target.value, dispatch, setLinkedDateFilterId, today, dateDiffMeta);
      setFilterDateType(event.target.value);
    },
    [linkedDateFilterId, linkedStatusHistoryFilter, dateValue, dispatch, setLinkedDateFilterId, today, dateDiffMeta]
  );

  const handleDateChange = useCallback(
    (newValue) => {
      linkedDateFilterId && dispatch(RemoveFilterById(linkedDateFilterId));
      linkedStatusHistoryFilter && dispatch(RemoveStatusHistoryFilter(linkedStatusHistoryFilter));
      handleAddDateFilter(newValue, filterDateType, dispatch, setLinkedDateFilterId, today, dateDiffMeta);
      setDateValue(newValue);
    },
    [linkedDateFilterId, linkedStatusHistoryFilter, , dispatch, setLinkedDateFilterId, today, dateDiffMeta]
  );

  const handleFilterReceivedChange = useCallback(
    (e: any) => {
      setFilterReceived(e.target.checked);
      cacheService.SetPageFilterByKey(location.pathname, "received", e.target.checked);
    },
    [location.pathname]
  );

  const handleFilterIdentifiedChange = useCallback(
    (event) => {
      setFilterIdentified(event.target.checked);
      cacheService.SetPageFilterByKey(location.pathname, "identified", event.target.checked);
    },
    [location.pathname]
  );

  const handleBook = useCallback(
    (id: number) => {
      assetService
        .UpdateMetadataFields(
          new UpdateMetadataFieldsRequest({
            metadata: [
              CreateNewDbMetadataValue(
                prgReserverMeta!.id,
                BaseMetadataType.DbBoolMetadataValueInfos,
                "rc_prg_reserver",
                true
              ),
            ],
            objectId: id,
          })
        )
        .then((res) => {
          if (res.success) {
            setRows((x) =>
              x.map((r) => {
                if (r.id === id) {
                  return { ...r, rc_prg_reserver: true };
                } else return r;
              })
            );
            enqueueCustomSnackbar(t("alert:success.metadataUpdated"), "success");
          } else enqueueCustomSnackbar(t("alert:error.updatingMetadata"), "error");
        });
    },
    [prgReserverMeta?.id]
  );

  const handleSendNas = useCallback((id: number) => {}, []);

  const handleIdentify = useCallback(
    (id: number) => {
      openModal &&
        openModal<ModalSetPrgIdAdamElementProps>(ModalSetPrgIdAdam, {
          onConfirm: (value: string) => {
            assetService
              .UpdateMetadataFields(
                new UpdateMetadataFieldsRequest({
                  metadata: [
                    CreateNewDbMetadataValue(
                      prgIdMeta!.id,
                      BaseMetadataType.DbStringMetadataValueInfos,
                      "rc_prg_id",
                      value
                    ),
                  ],
                  objectId: id,
                })
              )
              .then((res) => {
                if (res.success) {
                  enqueueCustomSnackbar(t("alert:success.metadataUpdated"), "success");
                  setRows((x) =>
                    x.map((r) => {
                      if (r.id === id) {
                        return { ...r, rc_prg_id: value };
                      } else return r;
                    })
                  );
                } else enqueueCustomSnackbar(t("alert:error.updatingMetadata"), "error");
              });
          },
        });
    },
    [prgIdMeta?.id]
  );

  const handleFilterChannelChange = useCallback(
    (value) => {
      if (!channelMeta || !channelChildMeta) return;

      const chaineValues = value.filter((x) => !x.includes("OKOO"));
      const subChaineValues = value.filter((x) => x.includes("OKOO"));

      if (chaineValues.length > 0) {
        const metaValue = {
          $type: ComputeMetadataBaseType(BaseMetadataType.DbStringMultiMetadataValueInfos),
          id: channelMeta.id,
          fieldType: BaseMetadataType.DbStringMultiMetadataValueInfos,
          value: chaineValues,
          creationTime: new Date().toISOString(),
          updateTime: null,
          fieldName: null,
          fieldLabel: null,
          targetLayer: ObjectLayer.Asset,
          valueLabel: null,
        };
        dispatch(AddOrUpdateFilter(metaValue));
      } else {
        dispatch(RemoveFilterById(channelMeta.id));
      }

      if (subChaineValues.length > 0) {
        const metaValueSub = {
          $type: ComputeMetadataBaseType(BaseMetadataType.DbStringMultiMetadataValueInfos),
          id: channelChildMeta.id,
          fieldType: BaseMetadataType.DbStringMultiMetadataValueInfos,
          value: subChaineValues,
          creationTime: new Date().toISOString(),
          updateTime: null,
          fieldName: null,
          fieldLabel: null,
          targetLayer: ObjectLayer.Asset,
          valueLabel: null,
        };
        dispatch(AddOrUpdateFilter(metaValueSub));
      } else {
        dispatch(RemoveFilterById(channelChildMeta.id));
      }
      setPageCache();
    },
    [channelMeta, setPageCache]
  );

  const handleResetDateField = useCallback(() => {
    setDateValue([null, null]);
    dispatch(RemoveFilterById(linkedDateFilterId));
    dispatch(RemoveStatusHistoryFilter(linkedStatusHistoryFilter));
  }, [linkedDateFilterId, linkedStatusHistoryFilter]);

  const handleInputKeydown = useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      if (event.key === "Enter") search();
    },
    [search]
  );

  const handleInputChange = useCallback((value) => setSearchText(value.target.value), []);

  const handleRowClick = useCallback(
    (row, event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
      if ((event?.nativeEvent?.target as any)?.nodeName === "IMG") {
        setAnchorEl(event.nativeEvent.target as HTMLElement);
        handleThumbnailClick(row.row.id);
      } else OpenLinkInNewTab(routePaths.asset.path + "/" + row.row.id);
    },
    [handleThumbnailClick]
  );

  const handleMouseMove = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      if (!(spliceThumbnailUrl && spliceThumbnailUrl !== "")) return;

      let posInDiv = e.clientX - e.currentTarget.getBoundingClientRect().left;
      let divWidth = e.currentTarget.getBoundingClientRect().width;
      if (divWidth === 0) return;

      let blockWidth = divWidth / GlobalConst.BROWSER_IMG_SPRITE_COUNT; // Size of each block in px
      let percent = posInDiv / divWidth; // Position in the div in %
      let blockIndex = Math.trunc((percent * divWidth) / blockWidth); // Position in the div in blocks

      let offset = blockIndex * GlobalConst.BROWSER_IMG_SPRITE_HEIGHT_PX;
      setMouseOffset(-offset + Math.trunc((3 * blockIndex) / 5));
      const cursorVT = document.getElementById("vt");
      cursorVT &&
        cursorVT.setAttribute(
          "style",
          `left: ${posInDiv}px; position: absolute; top: 0; bottom: 0; width: 1px; background: ${theme.palette.primary.main}; z-index: 2600;`
        );
    },
    [spliceThumbnailUrl, setMouseOffset]
  );

  const handleMouseOver = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
  }, []);

  const handleMouseLeave = useCallback(() => {
    setMouseOffset(1);
  }, [setMouseOffset]);

  const filteredRows = useMemo(
    () =>
      rows
        .filter(
          (x) =>
            !filterReceived ||
            x.statusHistory?.find((y) => y.status === ObjectStatus.ParsedAndProbbed) !== undefined ||
            x.status === ObjectStatus.ParsedAndProbbed
        )
        .filter((x) => !filterIdentified || GetMetadataByTagName(x, "rc_prg_id")?.value !== null),

    [rows, filterReceived, filterIdentified]
  );

  const columns: GridColDef<DbAssetObjectInfos>[] = useMemo(
    () => [
      {
        field: "thumbnail",
        headerName: "Vignette",
        hideable: true,
        flex: CellSize.small,
        minWidth: CellSize.small,
        filterable: false,
        renderCell: (data) =>
          data?.row?.status !== ObjectStatus.New && data?.row?.status !== ObjectStatus.Undefined ? (
            <TableCellAdamVignette url={thumbnailService.GetThumbRefByObjectId(data?.row?.id, authKey!)} />
          ) : (
            <></>
          ),
      },
      {
        field: "id",
        headerName: t("table:headerName.idAsset"),
        flex: CellSize.small,
        minWidth: CellSize.small,
        renderCell: (data) => (
          <Link
            color="primary.text"
            underline="hover"
            component={RouterLink}
            to={`${routePaths.asset.path}/${data.value}`}
            target="_blank"
          >
            {data.value}
          </Link>
        ),
      },
      {
        field: "rc_prg_media_id",
        headerName: "Id Prg.",
        flex: CellSize.small,
        minWidth: CellSize.small,
        valueGetter: (data, row) => GetMetadataByTagName(row, "rc_prg_media_id")?.value,
      },
      {
        field: "object",
        headerName: "Infos",
        minWidth: CellSize.xlarge,
        flex: CellSize.xlarge,
        renderCell: (data) => <TableCellAdamObjectInfos asset={data.row} />,
      },
      {
        field: "durationSMPTE",
        headerName: "Durée",
        minWidth: CellSize.small,
        flex: CellSize.small,
      },
      {
        field: "source_lib_chaines",
        headerName: "Chaine",
        type: "singleSelect",
        valueOptions: CHANNELS_VALUE_LABEL,
        valueGetter: (data, row) => GetMetadataByTagName(row, "source_lib_chaines")?.value,
        valueFormatter: (value: string[] | null, row) =>
          Array.isArray(value)
            ? value
                .map((x) => CHANNELS_VALUE_LABEL.find((y) => y.value === x)?.miniLabel || "")
                .filter((x) => x)
                .join(", ") ?? "-"
            : value ?? "-",
        flex: CellSize.small,
        minWidth: CellSize.small,
      },
      {
        field: "statusHistory",
        headerName: t("table:headerName.dateIngest"),
        type: "date",
        valueGetter: (data, row) => {
          if (!data || !row) return;
          const foundLastParsedIndex = row.statusHistory?.findLastIndex(
            (x) => x.status === ObjectStatus.ParsedAndProbbed
          );
          if (row && row.statusHistory && foundLastParsedIndex && foundLastParsedIndex >= 0) {
            const parsedDate = row.statusHistory[foundLastParsedIndex].date;
            if (!parsedDate) return null;
            return new Date(parsedDate);
          } else {
            return null;
          }
        },
        flex: CellSize.small,
        minWidth: CellSize.small,

        renderCell: (data) => (
          <TableCellDateTime
            data={{ value: data.value ? { date: data.value } : data.value }}
            format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS_FR}
          />
        ),
      },
      {
        field: "status",
        headerName: t("common:status"),
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        type: "singleSelect",
        valueOptions: GetEnumValueLabelMap(ObjectStatus, GetObjectStatusLabel).filter(
          (x) => rows.findIndex((o) => o.status === x.value) >= 0
        ),
        renderCell: (data) => (
          <AssetStatus status={data.value} disabled={GetMetadataByTagName(data.row, "isDisabled")?.value} />
        ),
      },
      {
        field: "actions",
        headerName: "",
        type: "actions",
        align: "right",
        flex: CellSize.actionsDefault,
        minWidth: CellSize.actionsDefault,
        getActions: (params: GridRowParams) => {
          if (!params) return [];
          const result: any[] = [];
          if (UserHasAcl(AclTypes.aclMetadataUpdate))
            result.push(
              <Tooltip title={t("tooltip:title.sendToNasPostProduction")}>
                <GridActionsCellItem
                  icon={<AccountTreeIcon />}
                  onClick={() => handleSendNas(params?.row?.id)}
                  label="Envoi vers NAS post-prod"
                  disabled
                />
              </Tooltip>
            );

          if (UserHasAcl(AclTypes.aclMetadataUpdate))
            result.push(
              <Tooltip title={t("modal:title.identifyAsset")}>
                <GridActionsCellItem
                  icon={<FingerprintIcon />}
                  onClick={() => handleIdentify(params?.row?.id)}
                  label={t("common:identifier")}
                />
              </Tooltip>
            );

          if (!params?.row?.rc_prg_reserver && UserHasAcl(AclTypes.aclMetadataUpdate))
            result.push(
              <Tooltip title={t("tooltip:title.bookAsset")}>
                <GridActionsCellItem icon={<BookIcon />} onClick={() => handleBook(params?.row?.id)} label="Réserver" />
              </Tooltip>
            );

          return result;
        },
      },
    ],
    [rows, handleBook, handleIdentify, handleSendNas]
  );

  const filterTop = useMemo(
    () => (
      <Stack direction={"row"} display={"flex"} justifyContent={"space-between"} width={"100%"}>
        <FiltersList
          sx={{ mb: 2, pt: 2 }}
          layer={ObjectLayer.Asset}
          type={MetadataFieldValueObjectTypes.DbAssetObjectInfos}
        />
        <Stack alignItems={"center"} direction={"row"}>
          <FormControlLabel
            checked={filterReceived}
            onChange={handleFilterReceivedChange}
            control={<Checkbox color="info" />}
            label={t("field:label.sourceReceived")}
          />
          <FormControlLabel
            checked={filterIdentified}
            onChange={handleFilterIdentifiedChange}
            control={<Checkbox color="info" />}
            label={t("field:label.sourceIdentified")}
            sx={{ p: 0, m: 0 }}
          />
        </Stack>
      </Stack>
    ),
    [
      filterReceived,
      filterIdentified,
      handleFilterReceivedChange,
      handleFilterIdentifiedChange,
      filters,
      filters.length,
    ]
  );

  useAdamDateFilterLinkValues(
    dateValue,
    setDateValue,
    linkedDateFilterId,
    linkedStatusHistoryFilter,
    filters,
    statusHistoryFilter
  );

  const pageHeaderLeft = useMemo(
    () => (
      <ListPageHeaderLeft height={"48px"} title="">
        <Select
          onChange={handleFilterDateType}
          sx={{ height: "32px", mr: 2 }}
          startAdornment={<CalendarMonthIcon />}
          value={filterDateType}
        >
          <MenuItem value="rc_prg_datesheures_diffs">{t("field:placeholder.broadcastingDate")}</MenuItem>
          <MenuItem value="ingest">{t("field:placeholder.depositeDate")}</MenuItem>
        </Select>
        <DateRangePicker
          slotProps={{
            shortcuts: {
              items: shortcutsItems,
              subheader: (
                <Button
                  onClick={() => {
                    handleDateChange([null, dateValue[1]]);
                  }}
                  endIcon={<CloseOutlined />}
                >
                  Clear start date
                </Button>
              ),
            },
            textField: { size: "small" },
          }}
          disableHighlightToday
          closeOnSelect={false}
          displayWeekNumber={true}
          fixedWeekNumber={5}
          showDaysOutsideCurrentMonth={true}
          slots={{ field: SingleInputDateRangeField }}
          sx={{ position: "relative", bottom: "12px" }}
          value={dateValue}
          onChange={handleDateChange}
          format="DD/MM/YYYY"
        />
        <Button
          onClick={handleResetDateField}
          variant="outlined"
          color="primary"
          disabled={!dateValue[0] && !dateValue[1]}
        >
          {t("common:reset")}
        </Button>
      </ListPageHeaderLeft>
    ),
    [filterDateType, handleFilterDateType, dateValue[0], dateValue[1], handleDateChange, shortcutsItems]
  );

  const pageHeaderRight = useMemo(
    () => (
      <ListPageHeaderRight>
        <OutlinedInput
          sx={{ width: "250px" }}
          label={t("common:search")}
          placeholder={t("field:placeholder.searchByExpression")}
          value={searchText}
          onChange={handleInputChange}
          onKeyDown={handleInputKeydown}
          endAdornment={
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          }
        />
        <Button onClick={search} variant="contained" color="primary" startIcon={<SearchIcon />}>
          {t("common:search")}
        </Button>
      </ListPageHeaderRight>
    ),
    [searchText, handleInputChange, handleInputKeydown, search]
  );
  const tableMemo = useMemo(
    () => (
      <DataTable
        loading={isLoading}
        tableKey={TableUuids.ADAM_SOURCES}
        columns={columns}
        rows={filteredRows}
        columnHeaderHeight={24}
        pagination={true}
        densityControl
        initialState={{
          pinnedColumns: { right: ["actions"] },
        }}
        onRowClick={handleRowClick}
      />
    ),
    [columns, isLoading, filteredRows, handleRowClick]
  );

  const thumbnailMenu = useMemo(
    () => (
      <Menu
        id="long-menu"
        slotProps={{
          paper: {
            style: {
              maxHeight: `${GlobalConst.BROWSER_IMG_SPRITE_HEIGHT_PX}px`,
              width: `${GlobalConst.BROWSER_IMG_SPRITE_HEIGHT_PX * (currentWidth / currentHeight)}px`,
              overflow: "hidden",
            },
          },
          list: {
            style: { display: "flex", justifyContent: "center" },
          },
        }}
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
      >
        <AdamThumbnailBody
          spliceThumbnailUrl={spliceThumbnailUrl}
          thumbnailUrl={thumbnailUrl}
          onMouseOver={handleMouseOver}
          mouseOffset={mouseOffset}
          techW={currentWidth}
          techH={currentHeight}
        >
          <figure onMouseLeave={handleMouseLeave} onMouseMove={handleMouseMove}>
            <Box
              width={`${GlobalConst.BROWSER_IMG_SPRITE_HEIGHT_PX * (currentWidth / currentHeight)}px`}
              height={`${GlobalConst.BROWSER_IMG_SPRITE_HEIGHT_PX}px`}
            >
              <div id="vt"></div>
            </Box>
          </figure>
        </AdamThumbnailBody>
      </Menu>
    ),
    [
      anchorEl,
      openMenu,
      handleClose,
      spliceThumbnailUrl,
      thumbnailUrl,
      handleMouseOver,
      mouseOffset,
      handleMouseLeave,
      handleMouseMove,
    ]
  );

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {filterTop}
        <AdamChannelsPageFilters
          setFilterChannel={handleFilterChannelChange}
          filterChannel={filterChannel}
          rows={rows}
          isSearch={true}
        />
        <ListPageHeader sx={{ mb: 0 }}>
          {pageHeaderLeft}
          {pageHeaderRight}
        </ListPageHeader>
      </LocalizationProvider>
      {tableMemo}
      {thumbnailMenu}
    </>
  );
};

export default AdamSources;
